import { DemoButton } from '@web/components/DemoButton'
import SolutionsIntroAccordion from '@web/components/SolutionsIntroAccordion'

export default function IntroSection() {
  return (
    <section className="py-16 bg-white md:py-24">
      <div className="flex px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col items-start gap-8">
          <div className="grid grid-cols-1 mt-8 md:grid-cols-[48%_52%] -mx-8">
            <div className="flex flex-col items-start gap-6 px-8">
              <h1 className="text-4xl font-light leading-tight tracking-tight text-text-primary sm:text-5xl lg:text-[52px] lg:leading-tight">
                What is
                <br />
                Resilience Explorer®?
              </h1>
              <p className="text-lg leading-snug text-text-secondary">
                Resilience Explorer® is an organisational risk platform for embedding hazard and
                climate risk into planning, investment, and governance decisions.
              </p>
              <p className="text-lg leading-snug text-text-secondary">
                It goes beyond identifying where hazards occur. It shows what happens next.
              </p>
              <p className="text-lg leading-snug text-text-secondary">
                When a flood affects a substation, the impact does not stop there. Power is lost.
                Water treatment can fail. Roads may close. Communities can become isolated. Most
                approaches stop at hazard exposure. Resilience Explorer® supports understanding of
                the consequences.
              </p>
              <p className="text-lg leading-snug text-text-secondary">
                The platform brings together exposure, vulnerability, and interdependencies to
                represent how impacts move through infrastructure systems and communities. This
                enables planners, asset managers, and emergency leaders to work from a shared,
                consistent evidence base that is updated as new data becomes available.
              </p>
              <p className="text-lg leading-snug text-text-secondary">
                Decisions are increasingly subject to scrutiny. Organisations must demonstrate how
                risk is understood, how it is managed, and how it informs planning and investment.
              </p>
              <p className="text-lg leading-snug text-text-secondary">
                Resilience Explorer® supports this by providing transparent analysis and
                documentation. It enables organisations to test options, understand trade-offs, and
                maintain a clear and defensible evidence base for decision-making over time.
              </p>
            </div>
            <div className="flex px-8 pt-16">
              <div className="flex flex-col items-start w-full gap-12">
                <SolutionsIntroAccordion />
                <DemoButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
